<template>
	<div class="c-rating" @click="goToReviews()">
		<div class="c-rating__icons">
			<StarIcon :class="{ 'icon--active': review.rating >= 1 }"></StarIcon>
			<StarIcon :class="{ 'icon--active': review.rating >= 2 }"></StarIcon>
			<StarIcon :class="{ 'icon--active': review.rating >= 3 }"></StarIcon>
			<StarIcon :class="{ 'icon--active': review.rating >= 4 }"></StarIcon>
			<StarIcon :class="{ 'icon--active': review.rating >= 5 }"></StarIcon>
		</div>

		<div class="c-rating__numbers" v-if="number">
			<p v-if="number == 'amount'">{{ review.amount }}</p>
			<p v-if="number == 'rating'">{{ review.rating }}</p>
		</div>
	</div>
</template>

<script>
import StarIcon from "@web/assets/icon/fadedStar.svg";

export default {
	name: "Rating",
	props: {
		button: {
			type: Boolean,
			default: false,
		},
		number: {
			type: String,
			default: "",
		},
		review: {
			type: Object,
			default: {
				amount: 0,
				rating: 0,
			},
		},
	},
	components: {
		StarIcon,
	},
	methods: {
		goToReviews() {
			var element = document.querySelector("#reviews");
			var topOfElement = element.offsetTop - 275;
			window.scrollTo({ top: topOfElement, left: 0, behavior: "smooth" });
			this.$emit("scrollToReviews");
		},
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.c-rating {
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 8px;

	&__icons {
		display: flex;
		align-items: center;
		gap: 4px;

		svg {
			width: 15px;
			height: 15px;
		}

		.icon {
			&--active {
				path {
					fill: $c-blue;
				}
			}
		}
	}

	&__numbers {
		display: flex;
		align-items: center;

		p {
			font-size: $font-disclaimer-size;
			line-height: $font-disclaimer-size;
			font-weight: $f-regular;
		}
	}

	&__link {
		display: flex;
		align-items: center;
		.o-link {
			font-weight: $f-bold;
		}
	}
}
</style>
